import { PostComisionManualExcel } from "../../../reducers/comisionManual";

export interface CargaComisionesManualesStore extends PostComisionManualExcel {}

export const cargaComisionesManualesStore: (
  state
) => CargaComisionesManualesStore = state => {
  const comisionManualState = state.comisionManual;

  return {
    comisionManualCarga: comisionManualState.comisionManualCarga,
    postingComisionManualExcel: comisionManualState.postingComisionManualExcel,
    postingComisionManualExcelError:
      comisionManualState.postingComisionManualExcelError
  };
};
